import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  public headerTitle$!: Observable<string>;
  private title: BehaviorSubject<string>;

  constructor() {
    this.title = new BehaviorSubject('');
    this.headerTitle$ = this.title.asObservable();
  }

  public setTitle(title: string): void {
    this.title.next(title);
  }
}
